import { axios } from './axios.js';

// This file is how it was implemented in the 'dev-kr' branch
// If it does not work, check if the backend has the correct implementation

export const createQuotation = async (cadFileID, data) => {
  //FROM GPT!! didn't read
  try {
    if (!cadFileID) {
      throw new Error('CAD File ID is required');
    }

    if (!data) {
      throw new Error('Form data is required');
    }

    const formData = new FormData();

    if (data && typeof data === 'object') {
      Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });
    }

    const res = await axios({
      method: 'post',
      url: `/quotation/${cadFileID}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        accept: 'application/json',
      },
    });

    if (!res.data) {
      throw new Error('No data received from server');
    }

    return res.data;
  } catch (error) {
    console.error('Error in createQuotation:', error);
    // Add more specific error handling if needed
    if (error.response) {
      throw new Error(error.response.data.response);
    }
    throw error;
  }
};

export const updateOwnerQuotation = async (quotationID, data) => {
  const res = await axios.putForm(`/quotation/owner/${quotationID}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
      accept: 'application/json',
    },
  });

  return res.data;
};

export const createBuyerQuotation = async (quotationID, data) => {
  const res = await axios.post(`/quotation/buyer/${quotationID}`, data);

  return res.data;
};

export const getQuotation = async cadFileID => {
  const res = await axios.get(`/quotation/${cadFileID}`);

  return res.data;
};

export async function updateBuyerQuotationStatus(buyerQuotationID, payload) {
  return axios.post(`/quotation/update-status/${buyerQuotationID}`, payload);
}

export async function getOwnedQuotations(
  limit,
  offset,
  search,
  sort,
  sortType,
) {
  const params = new URLSearchParams();
  params.append('offset', offset);
  params.append('limit', limit);
  params.append('search', search);
  params.append('sort', sort);
  params.append('sortType', sortType);

  return axios.get('/quotation', { params }).then(res => res.data);
}

export const getPlaceAutoComplete = async query => {
  const res = await axios.get(`/util/place/autocomplete?query=${query}`);

  return res.data;
};

export const getQuotationCategories = async () => {
  const res = await axios.get('/quotation/categories');

  return res.data;
};

export const getPlaceSuggestion = async queryString => {
  const res = await axios.get(`/util/place/autocomplete?query=${queryString}`);

  return res.data;
};

export const getPublicQuotations = async (
  limit = '',
  type = '',
  offset = '',
  minPrice = '',
  maxPrice = '',
  startDate = '',
  endDate = '',
  category = '',
  categoryLevel = '',
  location = '',
  locationRad = '',
  search = '',
  sortType = '',
  sort = '',
) => {
  const params = new URLSearchParams();
  params.append('limit', limit);
  params.append('type', type);
  params.append('offset', offset);
  params.append('minPrice', minPrice);
  params.append('maxPrice', maxPrice);
  params.append('startDate', startDate);
  params.append('endDate', endDate);
  params.append('category', category);
  params.append('categoryLevel', categoryLevel);
  params.append('location', location);
  params.append('locationRad', locationRad);
  params.append('search', search);
  params.append('sort', sort);
  params.append('sortType', sortType);

  const res = await axios.get('/quotation/public', { params });

  return res.data;
};

export const getGalleryQuotations = async (
  limit = '',
  type = '',
  offset = '',
  minPrice = '',
  maxPrice = '',
  startDate = '',
  endDate = '',
  category = '',
  categoryLevel = '',
  location = '',
  locationRad = '',
  search = '',
  sortOrder = '',
  sortBy = '',
) => {
  const params = new URLSearchParams();
  params.append('limit', limit);
  params.append('type', type);
  params.append('offset', offset);
  params.append('minPrice', minPrice);
  params.append('maxPrice', maxPrice);
  params.append('startDate', startDate);
  params.append('endDate', endDate);
  params.append('category', category);
  params.append('categoryLevel', categoryLevel);
  params.append('location', location);
  params.append('locationRad', locationRad);
  params.append('search', search);
  params.append('sortBy', sortBy);
  params.append('sortOrder', sortOrder);

  const res = await axios.get('/quotation/gallery', { params });

  return res.data;
};
